(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('DinghyEventDeleteController',DinghyEventDeleteController);

    DinghyEventDeleteController.$inject = ['$uibModalInstance', 'entity', 'DinghyEvent'];

    function DinghyEventDeleteController($uibModalInstance, entity, DinghyEvent) {
        var vm = this;

        vm.dinghyEvent = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            DinghyEvent.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
